import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CloseButton,
  Container,
  Modal,
  ModalContent,
  Wrapper,
} from "../style/view.styles";
import { Sidebar, SidebarContainer } from "../style/sidebar.styles";
import BackButton from "../components/Buttons/BackButton";
import { getLoggedInUser } from "../utils/AuthHandler";
import JoinProgramForm from "../components/Elements/JoinProgramForm";
import ProgramDetailsBody from "../components/Elements/ProgramDetailsBody";

export default function ProgramDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const program = location.state?.program || null;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const handleApplyModalClose = () => setIsApplyModalOpen(false);
  const handleCancelModalClose = () => setIsCancelModalOpen(false);
  const [isApplicationSubmitted, setIsApplicationSubmitted] = useState(false);

  useEffect(() => {
    if (!program) {
      navigate("/programs");
    }
  }, [program, navigate]);

  useEffect(() => {
    const user = getLoggedInUser();
    setIsLoggedIn(!!user);
    setUser(user);
  }, []);

  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleApplyModalClose();
    }
  };

  if (!program) return null;

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <SidebarContainer>
            <Sidebar>
              <BackButton path="/programs" />
            </Sidebar>
          </SidebarContainer>
          <ProgramDetailsBody
            program={program}
            isLoggedIn={isLoggedIn}
            user={user}
            isApplyModalOpen={isApplyModalOpen}
            setIsApplyModalOpen={setIsApplyModalOpen}
            isApplicationSubmitted={isApplicationSubmitted}
          />
        </Container>
      </Wrapper>
      {isApplyModalOpen && (
        <Modal onClick={handleModalBackgroundClick}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={handleApplyModalClose}>X</CloseButton>
            <JoinProgramForm
              selectedProgram={program}
              handleModalClose={handleApplyModalClose}
              setIsApplicationSubmitted={setIsApplicationSubmitted}
            />
          </ModalContent>
        </Modal>
      )}
      {isCancelModalOpen && (
        <Modal
          selectedProgram={program}
          handleModalClose={handleCancelModalClose}
        />
      )}
    </>
  );
}
